import { DateTime } from 'luxon';

// TODO: Import this from enterprise-framework-core next time we bring in the latest

export function ltLuxon(input: string | Date): DateTime {
	let output;

	if (typeof input === 'string') {
		output = DateTime.fromISO(input);
		if (output.isValid) return output;

		output = DateTime.fromRFC2822(input);
		if (output.isValid) return output;

		output = DateTime.fromHTTP(input);
		if (output.isValid) return output;

		// Maybe native JS Date can parse it?
		output = DateTime.fromJSDate(new Date(input));
		if (output.isValid) return output;
	} else if (typeof input === 'object' && input instanceof Date) {
		output = DateTime.fromJSDate(input);
		if (output.isValid) return output;
	}

	throw new Error('Unsupported input type');
}
